<template>
  <span>
    <span v-if="iconStack" class="fa-stack icon-fa-fixed-width">
      <i :class="[iconStackStyle, 'fa-xs', 'fa-stack-1x', iconStack, iconStackClass, 'icon-stack-bg-size']"></i>
      <i :class="[iconStyle, icon, 'fa-stack-1x', iconClass]"></i>
    </span>
    <i v-if="!iconStack" :class="[iconStyle, icon, iconClass, fixedWidth ? 'icon-fa-fixed-width' : '']"></i>
  </span>
</template>

<style scoped>
.icon-stack-bg-size {
  font-size: 0.5rem;
}
.icon-fa-fixed-width {
  /* Local version of 'fa-fw' but with overrides as fa-stack messes up the fixed width class */
  width: 1.25em !important;
  text-align: center;
}
</style>

<script>
export default {
  name: 'Icon',
  props: {
    iconStyle: {
      type: String,
      default: 'far'
    },
    iconStackStyle: {
      type: String,
      default: 'fas'
    },
    fixedWidth: Boolean,
    icon: String,
    iconStack: String,
    iconClass: String,
    iconStackClass: String
  }
}
</script>